export default __webpack_public_path__ + "7195ecfa42347e19b4e14cbc67d327e9.png";